<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p>{{ data.prompt }}</p>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="piButton"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Confirm
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">
    Cancel
  </button>
</div>
